import React from "react";
import { CreditUnionsLayout } from "@/modules/credit-unions/components/CreditUnionsLayout";

export const CreditUnions: React.FC = () => <CreditUnionsLayout />;
